import * as Yup from 'yup';

import { translate } from '@utils';

import { PaymentStatusTypes } from './paymentStatus.types';

export const getValidationSchema = () => {
  return Yup.string<PaymentStatusTypes>().required(
    translate('subModules/paymentStatus:validation.required')
  );
};
